<div class="container-fluid">
  <h5>{{'feature.search.panel' | translate}}</h5>
  <select [(ngModel)]="indexName" class="form-select mb-3">
    <option [ngValue]="null" selected>{{'feature.search.select_index' | translate}}</option>
    <option value="song">{{'common.entity.song' | translate}}</option>
    <option value="album">{{'common.entity.album' | translate}}</option>
    <option value="artist">{{'common.entity.artist' | translate}}</option>
  </select>
  <form [formGroup]="esForm">
    <div class="input-group mb-3">
      <label for="id">{{ 'feature.search.record_id' | translate }}</label>
      <div class="input-group">
        <input
          formControlName="id"
          id="id"
          type="number"
          class="form-control"
          [placeholder]="'feature.search.record_id_hint' | translate"
        />
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="createTime">{{ 'common.label.create_time' | translate }}</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="dd/MM/yyyy"
          id="createTime"
          name="dp"
          ngbDatepicker
          #d="ngbDatepicker"
          formControlName="createTime"
          [minDate]="minDate"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
            <i class="bi bi-calendar3"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="updateTime">{{ 'common.label.update_time' | translate }}</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="dd/MM/yyyy"
          id="updateTime"
          name="dp"
          ngbDatepicker
          #d="ngbDatepicker"
          formControlName="createTime"
          [minDate]="minDate"
        />
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
            <i class="bi bi-calendar3"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
  <button [disabled]="!indexName || (loading$ | async)" class="btn btn-primary m-1" (click)="reloadMapping()">
    {{'feature.search.reload_mapping' | translate}}
  </button>
  <button [disabled]="!indexName || (loading$ | async)" class="btn btn-primary m-1" (click)="markForSync()">
    {{'feature.search.mark_for_sync' | translate}}
  </button>
  <button [disabled]="!indexName || (loading$ | async)" class="btn btn-primary m-1" (click)="clearIndex()">
    {{'feature.search.clear_index' | translate}}
  </button>
  <button [disabled]="!indexName || (loading$ | async)" class="btn btn-primary m-1" (click)="resetIndex()">
    {{'feature.search.reset_index' | translate}}
  </button>
</div>
